var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"mb-12",attrs:{"justify":"start"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-parallax',{attrs:{"height":"300","src":"https://cdn.vuetifyjs.com/images/parallax/material2.jpg"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }